export const GOALS_TYPE = {
    COMPANY: 'company',
    ACCOUNT: 'account',
};

export const SELECTORS_PLACEHOLDERS = {
    GOAL: 'Goal',
    GOAL_STATUS: 'Status',
};

export const APPCUES_ID = {
    ADD_GOALS: 'COMPANY_ADD_GOALS',
};
